import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {UPDATE_MANAGEMENT_ERROR, UPDATE_MANAGEMENT_START, UPDATE_MANAGEMENT_SUCCESS} from "../../types";

export function* updateManagement({payload}) {
    try {
        const url = `/management/${payload.formData.id}/`;
        const method = 'PUT';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
        const data = (object) => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        const results = yield call(apiCall, url, method, data(payload.formData), headers);
        yield put({type: UPDATE_MANAGEMENT_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/management-data'));
    } catch (error) {
        yield put({type: UPDATE_MANAGEMENT_ERROR, error});
    }
}

export default function* update_management() {
    yield takeLatest(UPDATE_MANAGEMENT_START, updateManagement);
}